import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CustomGraphRootElement from './LineCharts/DataExploration';
import LineChartContainer from './LineCharts/LineChartContainer';
import ImageSlider from './CostSavings/ImageSlider';
import EULAHandler from './eulahandler';
import $ from 'jquery';
import { Button, Modal } from 'react-bootstrap';
import Cookies from 'cookies-js';
import YouTubeVideo from './YouTubeVideo';
import NoAccessPage from './NoAccessPage';
import HelpButton from './HelpButton';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Badge from 'react-bootstrap/Badge';
import "../css/custom.css"
import moment from 'moment';
//import "./css/custom"
import { useTranslation } from 'react-i18next';
import { DAFVisualisation } from "./DAFVisualisation";
import { useInterval } from "./useInterval";


//Show info modal if updated since last visit
var HomeTabVersion = Cookies.get('HomeTabVersion');
var CurrentHomeTabVersion = 3;

export function Home(props) {
    const { id } = useParams();
    const [showversioncontrolmodal, setShowVersionControlModal] = useState(false);

    const [showDAFVisualisation, setShowDAFVisualisation] = useState(false);

    const [isLive, setIsLive] = useState(true);
    const [customStartTime, setCustomStartTime] = useState('');
    const [customEndTime, setCustomEndTime] = useState('');

    const liveOptions = ['06 hours', '12 hours', '24 hours'];
    const [selectedLiveTimeRange, setSelectedLiveTimeRange] = useState('');

    const [dafData, setDafData] = useState([]);
    const [resetKey, setResetKey] = useState(0);
    const [loadingData, setLoadingData] = useState(false);

    const [showCostSavings, setShowCostSavings] = useState(false);
    const [costSavingsData, setCostSavingsData] = useState([]);

    const { t } = useTranslation();

    //This needs to be here because only the routed pages have access to id. This sends the id back to the navbar.
    useEffect(() => props.SiteGUIDSetter(id), [id]);

    function InitialiseDAFVisualisationData(timerange = selectedLiveTimeRange, live = isLive) {
        if (live) {
            var starttime;
            var endtime = moment();
            console.log(timerange);
            if (timerange === liveOptions[0]) {
                starttime = moment().subtract(6, 'hours');
            }
            else if (timerange === liveOptions[1]) {
                starttime = moment().subtract(12, 'hours');
            }
            else if (timerange === liveOptions[2]) {
                starttime = moment().subtract(24, 'hours');
            }
            if (starttime !== null) {
                setLoadingData(true);
                $.ajax({
                    url: '/api/DAFVisualisationAPI/GetDAFVisualisationData',
                    type: 'get',
                    data: { siteGUID: id, start: moment.utc(starttime).format(), end: moment.utc(endtime).format() },
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: response => {
                        setDafData(response);
                        setLoadingData(false);
                    },
                    error: reponse => {
                        //error message?
                    }
                });
            }
        }
        else if (customStartTime !== null && customEndTime !== null) {
            setLoadingData(true);
            $.ajax({
                url: '/api/DAFVisualisationAPI/GetDAFVisualisationData',
                type: 'get',
                data: { siteGUID: id, start: customStartTime, end: customEndTime },
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: response => {
                    setDafData(response);
                    setLoadingData(false);
                    console.log("DAF DATA checked")
                },
                error: reponse => {
                    //error message?
                }
            });
        }
    }

    function handleClose() {
        setShowVersionControlModal(false)
    }

    function CheckVersion() {
        if (HomeTabVersion < CurrentHomeTabVersion) {
            //Show modal and update home tab version for user so they don't see the message on other devices
            var fd = {
                "HomeTabVersion": CurrentHomeTabVersion
            };
            $.ajax({
                url: '/api/VersionControlAPI/SetHomeTabVersion',
                data: fd,
                type: 'get',
                success: function (response) {
                    HomeTabVersion = CurrentHomeTabVersion;
                    Cookies.set('HomeTabVersion', CurrentHomeTabVersion, { expires: 7999 });

                }
            });
            setShowVersionControlModal(true)
        }
    }


    useEffect(() => {
        $.ajax({
            url: '/api/CostSavingsAPI/GetCostSavingGraph',
            type: 'get',
            data: { siteGUID: id },
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: response => {
                setCostSavingsData(response);
                setShowCostSavings(true);
            },
            error: reponse => {
                setShowCostSavings(false);
            }

        });

        $.ajax({
            url: '/api/DAFVisualisationAPI/CheckDAFVisualisation',
            type: 'get',
            data: { siteGUID: id },
            contentType: "application/json; charset=utf-8",
            success: response => {
                setShowDAFVisualisation(true);
                setSelectedLiveTimeRange(liveOptions[0]);
                setIsLive(true);
                setDafData([]);
                InitialiseDAFVisualisationData(liveOptions[0], true);
            },
            error: reponse => {
                setShowDAFVisualisation(false);
                setDafData([]);
            }
        });
    }, [id])

    function ChangeCustomTimeRange(starttime, endtime) {
        setCustomStartTime(starttime);
        setCustomEndTime(endtime);
        setSelectedLiveTimeRange(null);
        setIsLive(false);
        setDafData([]);
    }

    function ChangeLiveTimeRange(value) {
        setSelectedLiveTimeRange(value);
        setIsLive(true);
        setDafData([]);
    }

    useEffect(() => {
        if (showDAFVisualisation) {
            InitialiseDAFVisualisationData();
        }
    }, [isLive, selectedLiveTimeRange, customStartTime, customEndTime, showDAFVisualisation]);

    

    useInterval(() => {
        var starttime;
        var endtime = moment();
        console.log(selectedLiveTimeRange);
        if (selectedLiveTimeRange === liveOptions[0]) {
            starttime = moment().subtract(6, 'hours');
        }
        else if (selectedLiveTimeRange === liveOptions[1]) {
            starttime = moment().subtract(12, 'hours');
        }
        else if (selectedLiveTimeRange === liveOptions[2]) {
            starttime = moment().subtract(24, 'hours');
        }
        if (starttime !== null) {
            $.ajax({
                url: '/api/DAFVisualisationAPI/GetDAFVisualisationData',
                type: 'get',
                data: { siteGUID: id, start: moment.utc(starttime).format(), end: moment.utc(endtime).format() },
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: response => {
                    setDafData(response);
                    console.log("DAF DATA checked")
                },
                error: reponse => {
                    //error message?
                }
            });
        }
    }, showDAFVisualisation && isLive && !loadingData ? 60 * 1000 : null);

    useEffect(() => {
        // Check access
        if (props.auth > 0) {
            // Version control modal
            CheckVersion()
            //First run
            if (HomeTabVersion == undefined || HomeTabVersion < CurrentHomeTabVersion) {
                //Get version from server
                $.ajax({
                    url: '/api/VersionControlAPI',
                    type: 'get',
                    success: function (response) {
                        console.log(response);

                        HomeTabVersion = response.homeTabVersion;
                        Cookies.set('HomeTabVersion', response.homeTabVersion, { expires: 7999 });
                        Cookies.set('AnalyticsTabVersion', response.analyticsTabVersion, { expires: 7999 });
                        Cookies.set('HealthSummaryTabVersion', response.healthSummaryTabVersion, { expires: 7999 });
                        Cookies.set('CostBreakdownTabVersion', response.costBreakdownTabVersion, { expires: 7999 });
                        Cookies.set('DeepDiveTabVersion', response.deepDiveTabVersion, { expires: 7999 });
                        Cookies.set('MaintenanceTabVersion', response.maintenanceTabVersion, { expires: 7999 });
                        Cookies.set('BillingTabVersion', response.billingTabVersion, { expires: 7999 });
                        Cookies.set('AlarmsTabVersion', response.alarmsTabVersion, { expires: 7999 });
                        Cookies.set('ControlTabVersion', response.controlTabVersion, { expires: 7999 });
                        Cookies.set('CalibrationsTabVersion', response.calibrationsTabVersion, { expires: 7999 });
                        Cookies.set('AirCleaningTabVersion', response.airCleaningTabVersion, { expires: 7999 });
                        Cookies.set('ReportsTabVersion', response.reportsTabVersion, { expires: 7999 });
                        Cookies.set('SiteDetailsTabVersion', response.siteDetailsTabVersion, { expires: 7999 });
                        Cookies.set('SignalSetupTabVersion', response.siteDetailsTabVersion, { expires: 7999 });
                        Cookies.set('DownloadsTabVersion', response.downloadsTabVersion, { expires: 7999 });

                        CheckVersion();
                    }
                });
            }

            
        }

    }, []);


    return (
        props.auth !== undefined ?
            props.auth > 0 ?
                <div className="custom-tab-content" >
                    <HelpButton showHelpModal={setShowVersionControlModal} />
                    {(showDAFVisualisation || showCostSavings) ?
                    <Tabs
                    defaultActiveKey="trendvisualisation"
                    id="justify-tab-example"
                    className="mb-3"
                    justify>
                        { showDAFVisualisation && <Tab eventKey="dafvisualisation" title={<>Live DAF Visualisation <Badge pill bg="danger">New Feature!</Badge></>}>
                                <DAFVisualisation
                                    dafData={dafData}
                                    key={resetKey}
                                    selectedLiveOption={selectedLiveTimeRange}
                                    liveOptions={liveOptions}
                                    changeLiveOption={ChangeLiveTimeRange}
                                    changeCustomTimeRange={ChangeCustomTimeRange}
                                    loadingData={loadingData}
                                />
                        </Tab> }
                            <Tab eventKey="trendvisualisation" title="Live Trend Visualisation">
                                <div className="d-flex fixed-buttons">
                                    <div className="ms-2" id="dataexplorationroot">
                                        <CustomGraphRootElement siteGUID={id} />
                                    </div>
                                    <div className="ms-2">
                                        <button id="resetzoombutton" className="btn btn-primary d-flex justify-content-center">{t('common.resetzoom')}</button>
                                    </div>
                                </div>
                                <LineChartContainer
                                    siteGUID={id}
                                    linecharttype={0}
                                    auth={props.auth}
                                />
                            </Tab>
                        
                        {showCostSavings && <Tab eventKey="savings" title={<>Cost Savings <Badge pill bg="danger">New Feature!</Badge></>}><ImageSlider savingsData={costSavingsData} /></Tab> }
                    </Tabs>  :
                            <><div className="d-flex fixed-buttons">
                                <div className="ms-2" id="dataexplorationroot">
                                    <CustomGraphRootElement siteGUID={id} />
                                </div>
                                <div className="ms-2">
                                    <button id="resetzoombutton" className="btn btn-primary d-flex justify-content-center">{t('common.resetzoom')}</button>
                                </div>
                            </div>
                            <LineChartContainer
                                siteGUID={id}
                                linecharttype={0}
                                auth={props.auth}
                            /></>
                    }
                    <Modal show={showversioncontrolmodal} onHide={handleClose} size="lg">
                        <Modal.Header closeButton>
                            <h5 className="modal-title" id="exampleModalLongTitle">{t('common.whatsnew')}</h5>
                        </Modal.Header>
                        <Modal.Body className="text-center">
                            {/* <YouTubeVideo VideoTag="Home" />
                            <p className="text-start">The new Streamwise D.I. portal brings new functionality and increased speed.</p>
                            <p><img className="w-100" src="/images/HowTos/home4.png" alt="Document Upload" /></p>
                            <p className="text-start">On the home page, you can create custom graphs.</p>
                            <p><img className="w-100" src="/images/HowTos/home1.png" alt="Document Upload" /></p> */}
                            <p><img className="w-100" src="/images/HowTos/home-v3.png" alt="Document Upload" /></p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                {t('common.close')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <EULAHandler />
                </div>
                :
                <NoAccessPage />
            : <></>);
};

